// Change this to http://localhost:8080 to test Express API hosted locally
// Or make it https://mycustomframe-eeb5c.uc.r.appspot.com to test Express API hosted on Google Cloud App Engine

// DEVELOPMENT MODE: Using local backend for testing
//const ENDPOINT_PATH = 'http://localhost:8080';

// PRODUCTION MODE: Uncomment this line when ready to deploy

const ENDPOINT_PATH = 'https://mycustomframe-eeb5c.uc.r.appspot.com';

export { ENDPOINT_PATH };
